<ag-grid-angular class="entity-list ag-theme-material" rowSelection="single" suppressCellFocus="true"
    [columnDefs]="columnDefs" [defaultColDef]="defaultColDef" (gridReady)="onGridReady($event)"
    suppressHorizontalScroll="true" (modelUpdated)="onGridReady($event)"
    [components]="components" [overlayLoadingTemplate]="'&nbsp;'" [sortingOrder]="['asc','desc']"
    [rowClassRules]="rowClassRules" [cacheBlockSize]="numberOfRawsInPage" [context]="context" [icons]="icons"
    rowModelType="infinite" [debug]="debugGrid" [rowHeight]="rowHeight" [headerHeight]="headerHeight"
    (sortChanged)="onSortChange($event)" (dragStopped)="onColDragEnd($event)"
    (viewportChanged)="onViewPortChanges($event)" (bodyScroll)="bodyScroll($event)">
</ag-grid-angular>
